import { useNavigate, useParams } from "react-router-dom";
import styles from "./EventSidebar.module.css";
import { NavLink } from "react-router-dom";
import React from "react";

function EventSidebar({ id }) {
  const navigate = useNavigate();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.website}>
        <h1>Banquetscheduler</h1>
      </div>
      <div className={styles.backButton}>
        <button
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
        >
          Back to Calendar
        </button>
      </div>
      <p className={styles.eventTitle}>Event {id}</p>
      <ul className={styles.menuList}>
        <li>Print Event Detail</li>
        <li>Print Customer Invoice</li>
        <li>Print Event Summary</li>
        <li>Copy Event</li>
        <li>Delete Event</li>
      </ul>

      <div className={styles.user}>
        <p>User: Username</p>
        <button>Logout</button>
      </div>
      <footer className={styles.footer}>
        <p className={styles.copyright}>
          &copy;{new Date().getFullYear()} by SFL Software
        </p>
      </footer>
    </aside>
  );
}

export default EventSidebar;
